import { ActionReducerMap, createSelector } from '@ngrx/store';
import * as fromEntityManager from './entity-manager-forms';
import * as fromProjects from './projects';
import * as fromSystem from './system';
import * as fromSystemConfig from './configuration';
import * as fromSystemUser from './system-user';

export { Store, select } from '@ngrx/store';

export interface RootReducerState {
  user: fromSystemUser.UserReducerState;
  config: fromSystemConfig.ConfigurationReducerState;
  entity_forms: fromEntityManager.EntityFormsReducerState;
  projects: fromProjects.ProjectReducerState;
  system: fromSystem.SystemReducerState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  user: fromSystemUser.SystemUserReducer,
  config: fromSystemConfig.ConfigurationReducer,
  entity_forms: fromEntityManager.EMFormsReducer,
  projects: fromProjects.ProjectsReducer,
  system: fromSystem.SystemsReducer,
};

export const getUserState = (state: RootReducerState) => state.user;

export const getUserPermissions = createSelector(getUserState, fromSystemUser.getUserPermissions);
export const getLoggedInUserStatus = createSelector(getUserState, fromSystemUser.getSystemUser);
export const getLoggedInUserOffices = createSelector(getUserState, fromSystemUser.getSystemUserOffices);
export const getUserLoading = createSelector(getUserState, fromSystemUser.getLoading);
export const getUserLoaded = createSelector(getUserState, fromSystemUser.getLoaded);

/** Authenticated profile from `/me` (same reference as permissions today). */
export const getUserProfile = createSelector(getUserState, fromSystemUser.getSystemUser);

/** @deprecated Use getUserProfile */
export const getUserData = getUserProfile;

//#region Configuration
export const getConfigState = (state: RootReducerState) => state.config;
export const getConfigMenu = createSelector(getConfigState, fromSystemConfig.getConfigurationMenu);
export const getPdfStatus = createSelector(getConfigState, fromSystemConfig.getPdfGeneratorActivity);
//#endregion

//#region Projects
export const getProjectState = (state: RootReducerState) => state.projects;
export const getAllProjects = createSelector(getProjectState, fromProjects.getProjectList);
export const projectInfo = createSelector(getProjectState, fromProjects.projectInfo);
export const getProjectLockingStatus = createSelector(getProjectState, fromProjects.getProjectAccessControlStatus);
export const getActiveProject = createSelector(getProjectState, fromProjects.getActiveProject);
export const getActiveProjectStatistics = createSelector(getProjectState, fromProjects.getActiveProjectStatistics);
//#endregion

//#region Entity Manager Forms
export const getEntityFormsState = (state: RootReducerState) => state.entity_forms;
export const getAllEntityManagerFormsList = createSelector(getEntityFormsState, fromEntityManager.getEntityManagerFormsList);
//#endregion

//#region System
export const getSystemState = (state: RootReducerState) => state.system;
export const getFields = createSelector(getSystemState, fromSystem.getFields);
export const getTagSetting = createSelector(getSystemState, fromSystem.getTags);
export const getMyOffices = createSelector(getSystemState, fromSystem.getMyOffices);
export const getUserNotes = createSelector(getSystemState, fromSystem.getNotes);
export const contactInfo = createSelector(getSystemState, fromSystem.getContact);

/** @deprecated Use getSystemState */
export const system = getSystemState;
/** @deprecated Use getConfigState */
export const getConfigStates = getConfigState;
/** @deprecated Use getProjectState */
export const getProjectStates = getProjectState;
/** @deprecated Use getEntityFormsState */
export const getEMFromStates = getEntityFormsState;
/** @deprecated Use getUserLoading */
export const getLoadingState = getUserLoading;
